import { ITransparencyBrandQuery } from '@/client/types/TransparencyBrand'
import { api } from '@/client/utils'

export const getTransparencyBrands = async (customerId: number | string, locale: string) => {
  const url = `/transparency/brands/${customerId}/${locale}`
  const { data } = await api.get<ITransparencyBrandQuery>(url)
  return data?.transparencyBrands
}

export const getTransLabelPreviews = async (data) => {
  const url = `/transparency/label/preview`
  return await api.post(url, data)
}
